module.exports = __webpack_public_path__ + "static/media/clw-logo.d8f900c5.png";